import { toast } from 'react-toastify';
const notificationOptions = {
    position: toast.POSITION.BOTTOM_RIGHT
};
const messageBuilder = (promise, messages) => toast.promise(promise, messages, notificationOptions);
const notificationMessages = {
    walletConnect: {
        pending: 'Connecting the wallet',
        success: 'Wallet connected successfully',
        error: 'Wallet connection failed'
    },
    walletSelect: {
        pending: 'Fetching the wallet'
    }
};
export const NotificationsService = {
    onWalletSelect: (promise) => messageBuilder(promise, notificationMessages.walletSelect),
    onWalletAuth: (promise) => messageBuilder(promise, notificationMessages.walletConnect)
};
